// src/services/pdf/core/layout.ts
// Page layout constants for the GP Summary PDF.

export const PAGE_LAYOUT = {
  // A4 dimensions in mm
  pageWidth: 210,
  pageHeight: 297,

  // Margins
  marginLeft: 15,
  marginRight: 15,
  marginTop: 15,
  marginBottom: 20,

  // Computed content area
  get contentWidth() {
    return this.pageWidth - this.marginLeft - this.marginRight;
  },

  // Spacing
  sectionGap: 8,
  subsectionGap: 4,
  lineHeight: 5,
  smallLineHeight: 4,

  // Font sizes (pt)
  fontSize: {
    title: 16,
    sectionTitle: 11,
    subsectionTitle: 9,
    body: 8,
    small: 7,
    tiny: 6,
  },
} as const;
